import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Divider, Grid, IconButton, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HomeIcon from '@mui/icons-material/Home';

export const SubHeader = ({ titulo }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const goBack = () => {
    window.history.back();
  };

  return (
    <Grid
      container
      justifyContent="center"
      sx={{ mt: 2, mb: 1 }}
    >
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        sx={{ width: '100%', maxWidth: '1200px', px: 2 }}
      >

        {/* Título */}
        <Typography
          variant="h5"
          sx={{
            fontWeight: 600,
            fontSize: { xs: 20, md: 26 }
          }}
        >
          {titulo.toUpperCase()}
        </Typography>

        {/* Acciones derecha */}
        {location.pathname !== "/" && (
          <Grid item>
            <IconButton color="primary" onClick={goBack}>
              <ArrowBackIcon />
            </IconButton>

            <IconButton color="primary" onClick={() => navigate("/")}>
              <HomeIcon />
            </IconButton>
          </Grid>
        )}
      </Grid>

      <Divider sx={{ width: '100%', mt: 1 }} />
    </Grid>
  );
};
